import { useState, useEffect } from 'react';

export const useEventImages = (event) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const getEventImages = (event) => {
    if (!event) return [];
    
    console.log('Evento completo per debug immagini:', event);
    
    let allImages = [];
    const imageSources = [
      event.images,
      event.image,
      event.gallery
    ];
    
    imageSources.forEach(source => {
      if (source && Array.isArray(source) && source.length > 0) {
        const processedImages = source.map(img => {
          console.log('Processando immagine:', img);
          
          // Formato Strapi v4/v5 con attributes
          if (img.attributes) {
            return {
              id: img.id,
              url: img.attributes.url,
              name: img.attributes.name || 'Immagine evento',
              alternativeText: img.attributes.alternativeText || event.title
            };
          }
          // Se già in formato semplice
          else if (img.url) {
            return {
              id: img.id || Math.random(),
              url: img.url,
              name: img.name || 'Immagine evento',
              alternativeText: img.alternativeText || event.title
            };
          }
          return null;
        }).filter(Boolean);
        
        allImages = [...allImages, ...processedImages];
      }
    });
    
    console.log('Immagini processate finale:', allImages);
    return allImages;
  };

  const eventImages = getEventImages(event);

  const nextSlide = () => {
    setCurrentSlideIndex((prev) => 
      prev === eventImages.length - 1 ? 0 : prev + 1
        );
  };

  const prevSlide = () => {
    setCurrentSlideIndex((prev) => 
      prev === 0 ? eventImages.length - 1 : prev - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  // Reset slide quando cambia evento
  useEffect(() => {
    setCurrentSlideIndex(0);
  }, [event?.id]);

  return {
    eventImages,
    currentSlideIndex,
    nextSlide,
    prevSlide,
    goToSlide
  };
};
